import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TypeAdresseFNS } from '../models/TypeAdresseFNS';
import { Step2 } from '../../../../shared/models/component-messages/blocCommun/simp/step2';
import { CTRL_268 } from '../../../validators/268/ctrl268';
@Component({
  selector: 'app-type-adresseFNS',
  templateUrl: './type-adresseFNS.component.html'
})
export class TypeAdresseFNSComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresseFNS';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;

  	@Input() organisme: TypeAdresseFNS;

    public step2 = new Step2();

    public rg1 = CTRL_268.id + '_1';

  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_268Names_json() }));
  }


  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_FNSimple_SepSep_TypeAdresseFNS_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }
}

